<template>
  <div class="nav">
    <div
      class="device-wrap"
      @click="showDevices"
      :class="{
        'device-wrap-active': isShowDevices,
        'device-wrap-hover':
          $store.state.bind_list && $store.state.bind_list.length > 1,
      }"
      v-if="
        $store.state.bind_list &&
        $store.state.bind_list.length > 0 &&
        $store.state.curDev
      "
    >
      <div
        class="device-icon device-icon-offline"
        v-if="$store.state.curDev.term && $store.state.curDev.term.status"
      >
        <div class="device-status device-status-offline"></div>
      </div>
      <div class="device-icon" v-else>
        <div class="device-status"></div>
      </div>
      <div
        class="device-name"
        :class="{
          'device-name-offline':
            $store.state.curDev.term && $store.state.curDev.term.status,
        }"
      >
        {{
          $store.state.curDev.term.comment
            ? $store.state.curDev.term.comment
            : $store.state.curDev.term.name
            ? $store.state.curDev.term.name
            : $store.state.curDev.peerid
        }}
      </div>

      <div
        class="device-arrow"
        v-if="$store.state.bind_list && $store.state.bind_list.length > 1"
      ></div>
    </div>
    <div class="device-wrap" v-else>
      <div class="device-icon device-icon-nobind"></div>
      <div class="device-name device-tips" v-if="$store.state.user.uid">
        未绑定设备
      </div>
      <div class="device-name device-tips" v-else>未登录</div>
    </div>
    <div
      class="device-count"
      v-if="$store.state.user.vip_left == 0 && $store.state.user.uid"
    >
      <span class="line"></span>
      每日免费使用数
      <div class="van-badge van-badge--fixed">{{ leftTimes }}</div>
    </div>
    <template v-if="$store.state.user.uid">
      <template
        v-if="$store.state.bind_list && $store.state.bind_list.length > 0"
      >
        <div @click="showAddDev" title="添加设备" class="add-btn"></div>
        <div @click="settingClick" title="设备详情" class="device-btn"></div>
      </template>
      <div class="bind-wrap" @click="showAddDev" v-else>
        <div class="bind-tips">绑定设备</div>
        <div class="arrow-icon"></div>
      </div>
    </template>

    <div class="menu_wrap" @click="onHideMenu" v-if="isShowDevices">
      <div
        :class="{
          menu: true,
          menu_windows: $store.state.client == 'windows',
        }"
      >
        <div class="menu_list" @mouseleave="onHideMenu">
          <div
            class="menu_item"
            :class="{
              menu_item_active: dev.peerid == $store.state.curDev.peerid,
            }"
            :key="dev.peerid"
            v-for="dev in $store.state.bind_list"
          >
            <div class="menu_item_text" @click="changeDev(dev)">
              {{
                dev.term.comment
                  ? dev.term.comment
                  : dev.term.name
                  ? dev.term.name
                  : dev.peerid
              }}
            </div>
            <div class="menu_item_hr"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    leftTimes: Number,
  },
  data: function () {
    return {
      isShowDevices: false,
    };
  },

  components: {},
  watch: {},
  mounted() {
    this.$store.state.curDev = JSON.parse(localStorage.getItem("jdxb-cueDev"));
  },
  methods: {
    ...mapActions(["sendUserlog"]),
    showSetting: function () {
      this.$store.state.isShowDeviceInfo = true;
    },
    hideSetting: function () {
      this.$store.state.isShowDeviceInfo = false;
    },
    onHideMenu: function () {
      this.isShowDevices = false;
    },
    showDevices: function () {
      if (
        this.$store.state.bind_list &&
        this.$store.state.bind_list.length > 1
      ) {
        this.isShowDevices = true;
      }
    },
    changeDev: function (dev) {
      localStorage.setItem("jdxb-cueDev", JSON.stringify(dev));

      this.$store.state.curDev = dev;
    },
    showAddDev: function () {
      let _that = this;
      let item = _that.$store.state.curDev;
      _that.sendUserlog(["add_device_click", ""]);
      this.$store.state.isShowAddDevice = true;
    },

    settingClick: function () {
      let _that = this;
      let item = _that.$store.state.curDev;
      _that.sendUserlog(["device_setting_click", ""]);
      _that.showSetting();
      // _that.$router.push({
      // 	path: "/home/node/manage",
      // 	query: { cur_pid: item.peerid },
      // });
      //   _that.$store.state.deviceForSetting = item;
      //   _that.$router.push({
      //     name: "DeviceSetting",
      //     params: { device: item },
      //   });
    },
  },
};
</script>

<style lang="less" scoped>
.menu_wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2001;
}

.menu {
  width: 175px;

  position: absolute;
  left: 10px;
  top: 35px;
  background-image: url("../../assets/common/menu/bg.svg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  // box-shadow: 0px 5px 5px #aaa;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  .menu_list {
    width: 173px;
    margin-top: 6px;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0px 2px 4px rgba(123, 130, 134, 0.24);
    max-height: 275px;
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .menu_list::-webkit-scrollbar {
    display: none;
  }
  .menu_item {
    width: 173px;
    border-bottom: 1px solid #f0f6ff;
  }
  .menu_item:hover,
  .menu_item_active {
    cursor: pointer;

    background-color: #f0f6ff;
    .menu_item_text {
      color: #4027c1;
      font-weight: bolder;
    }
  }
  .menu_item_text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
    font-size: 14px;
    height: 42px;
    line-height: 42px;
    color: #666666;
    margin: 0 auto;
    box-sizing: border-box;
    text-align: center;
  }
  //   .menu_item_hr {
  //     width: 175px;
  //     height: 1px;
  //     background-image: url("../../assets/common/menu/menu_item_hr.svg");
  //     background-size: 100% 100%;
  //     margin: 0 auto;
  //   }
}

.nav {
  width: 932px;
  height: 53px;
  padding-top: 1px;
  flex-shrink: 0;
  background-color: rgba(245, 237, 255, 0.4);
  background-image: url(../../assets/components/node/nodenav/home-nav-bg.png);
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 100% auto;
  position: relative;
  .device-wrap-hover:hover,
  .device-wrap-active {
    background: rgba(214, 211, 234, 0.5);
    cursor: pointer;
  }
  .device-wrap {
    height: 24px;
    line-height: 24px;
    margin-top: 5px;
    margin-left: 6px;
    float: left;
    padding: 8px 10px 5px 16px;
    border-radius: 24px;

    .device-icon {
      display: inline-block;
      vertical-align: top;
      width: 24px;
      height: 24px;
      background-image: url(../../assets/components/node/nodenav/device.svg);
      position: relative;
      .device-status {
        position: absolute;
        top: -3px;
        left: -3px;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background-color: #0dae1d;
      }
      .device-status-offline {
        background-color: #aaaaaa;
      }
    }
    .device-icon-nobind,
    .device-icon-offline {
      background-image: url(../../assets/components/node/nodenav/device-offline.svg);
    }
    .device-name {
      display: inline-block;
      vertical-align: top;
      color: #3345b3;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-left: 8px;
    }
    .device-name-offline {
      color: #4a4a4a;
    }
    .device-arrow {
      display: inline-block;
      vertical-align: top;
      margin-top: 6px;
      margin-left: 4px;
      width: 24px;
      height: 12px;
      background-image: url(../../assets/components/node/nodenav/arrow-down.svg);
    }
  }
  .device-count {
    position: relative;
    display: inline-block;
    top: 14px;
    font-size: 12px;
    color: #4a4a4a;
    .line {
      content: "";
      display: inline-block;
      width: 1px;
      height: 14px;
      margin: 0 12px;
      background: #999;
    }
    .van-badge {
      display: inline-block;
      box-sizing: border-box;
      min-width: 18px;
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      font-family: -apple-system-font, Helvetica Neue, Arial, sans-serif;
      line-height: 1.5;
      text-align: center;
      background-color: #fa5151;
      border-radius: 50%;
    }
    .van-badge--fixed {
      position: absolute;
      top: 0;
      right: -12px;
      transform: translate(50%, -50%);
      transform-origin: 100%;
    }
  }
  .device-btn {
    float: right;
    width: 24px;
    height: 24px;
    background-image: url(../../assets/components/node/nodenav/error.svg);
    background-size: 100% 100%;
    margin-top: 15px;
    margin-right: 28px;
    cursor: pointer;
    transform: rotate(180deg);
  }
  .device-btn:hover {
    opacity: 0.8;
  }
  .add-btn {
    float: right;
    width: 24px;
    height: 24px;
    background-image: url(../../assets/components/node/nodenav/add.svg);
    background-size: 100% 100%;
    margin-top: 15px;
    margin-right: 28px;
    cursor: pointer;
  }
  .add-btn:hover {
    opacity: 0.8;
  }

  .bind-wrap {
    float: right;
    margin-top: 15px;
    margin-right: 28px;
    cursor: pointer;

    height: 24px;
    line-height: 24px;
    .bind-tips {
      display: inline-block;
      vertical-align: top;
      line-height: 24px;
    }
    .arrow-icon {
      display: inline-block;
      vertical-align: top;
      width: 12px;
      height: 24px;
      background-image: url(../../assets/components/node/nodenav/arrow.svg);
      background-size: 100% 100%;
      margin-left: 12px;
      margin-top: 1px;
    }
  }
  .bind-wrap:hover {
    opacity: 0.8;
  }
}
</style>